import {DependencyList, RefObject, useEffect, useRef, useState} from 'react';

interface Options {
  once?: boolean;
}

export function useHover<Surface extends Element>(
  providedRef: RefObject<any>,
  options?: Options,
  deps?: DependencyList,
) {
  const fallbackRef = useRef<Surface>(null);
  const ref = providedRef || fallbackRef;
  const {once} = Object.assign({once: false}, options);
  const [mouseOver, setMouseOver] = useState(false);

  const handleMouseOver = () => {
    setMouseOver(true);
  };

  const handleMouseOut = () => {
    setMouseOver(false);
  };

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseenter', handleMouseOver, {once});
      node.addEventListener('mouseleave', handleMouseOut, {once});

      return () => {
        node.removeEventListener('mouseenter', handleMouseOver);
        node.removeEventListener('mouseleave', handleMouseOut);
      };
    }
  }, [ref.current, once, ...(deps || [])]);

  return {ref, mouseOver};
}
